<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.id">Edit</template><template v-else>New</template> Schedule</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitSchedule()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Schedule</span><span v-if="saved">Schedule Saved</span></button>
        </div>
      </div>
      <div class="schedulesDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="schedule.title" placeholder="Annual Training Schedule" class="w3-input w3-border" />
              </div>
              <div class="input-row w3-padding-8">
                <label>Content</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="schedule.content"></tinymce-editor>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
          <header class="w3-left-align">Details</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Status</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="schedule.status">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsscheduledetail',
  data() {
    return {
      state: dataStore.state,
      schedule: {
        title: '',
        content: '',
      },
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initSchedule()
    if (this.$route.params.title) {
      for (let savedSchedule of this.state.siteData.content.sidebar.sections.schedule.items) {
        if (savedSchedule.title === this.$route.params.title) {
          this.schedule = savedSchedule
          break
        }
      }
    }
  },
  methods: {
    initSchedule() {
      this.schedule = {
        title: '',
        content: '',
      }
    },
    saveContent() {
      let loopIndex = 0
      let found = false
      for (let schedule of this.state.siteData.content.sidebar.sections.schedule.items) {
        if (schedule.title === this.schedule.title) {
          if (!confirm('Schedule with this Name already exists, overwrite?')) {
            return
          } else {
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.content.sidebar.sections.schedule.items[loopIndex] = this.schedule
      } else {
        this.state.siteData.content.sidebar.sections.schedule.items.push(this.schedule)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace('/cms/schedules')
        }
      })
    },
    exitSchedule() {
      this.initSchedule()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .schedulesImagesGrid {display:grid; grid-template-columns: repeat(3, 1fr); grid-gap: 8px;}

  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .schedulesDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
@media screen and (max-width:993px) {
  .schedulesImagesGrid {grid-template-columns: 1fr;}
  .schedulesDetailGrid {grid-template-columns: 1fr;}
  .headerGridCMS {grid-template-columns: 1fr 1fr;}
  /* .cardRow {grid-template-columns: 1fr;} */
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSchedulesDetail.vue